import React from "react";
import { StyleSheet, Text, View } from "react-native";

const RupeeVal = ({ rupeeVal, customStyle = {}, isZeroCheck = false }) => {
  return (
    <View style={[styles.rupeeBlock, customStyle]}>
      <Text style={[styles.rupeeBlock, customStyle]}>
        {rupeeVal || isZeroCheck ? "" + rupeeVal : "-"}
      </Text>
    </View>
  );
};

export default RupeeVal;

const styles = StyleSheet.create({
  rupeeBlock: {
    flexDirection: "row",
  },
});
